const API_URL = import.meta.env.VITE_API_URL
const CDN_URL = import.meta.env.VITE_API_URL

export interface RequestOptions {
  body?: any
  headers?: { [key: string]: string }
  method?: string
  mode?: RequestMode
  signal?: AbortSignal
}

export const fetchApi = async (resource: string, options?: RequestOptions) => {
  const url = `${API_URL}${resource}`

  const { headers, ...optionsExceptHeaders } = options || {}
  const requestOptions = {
    ...optionsExceptHeaders,
    headers: {
      ...(headers ? headers : {}),
    },
  }

  const response = await fetch(url, requestOptions)

  if (response.ok) {
    return response.json()
  }

  const errorMessage = response.statusText || `HTTP Error: ${response.status}`;
  throw new ResponseError(errorMessage, response)
}

export const fetchCdn = async (resource: string, options?: RequestOptions) => {
  const url = `${CDN_URL}${resource}`

  const { headers, ...optionsExceptHeaders } = options || {}
  const requestOptions = {
    ...optionsExceptHeaders,
    headers: {
      ...(headers ? headers : {}),
    },
  }

  const response = await fetch(url, requestOptions)

  if (response.ok) {
    return response.json()
  }

  throw new ResponseError(response.statusText, response)
}

export class ResponseError extends Error {
  response = null

  constructor(message: string, res: any) {
    super(message)
    this.response = res
  }
}
